import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/styles/main-theme.css';
import '@/styles/tokens.css';
import '@/styles/globals.css';
import '@/styles/semantic-theme.css';
import '@/styles/utilities.css';
import '@/shared/components/create-form-dialog.css';
import '@/shared/components/inline-feedback.css';
import './shared/components/patterns/patterns.css';
import '@/app/styles/app-shell.css';
import '@/app/styles/app-header.css';
import '@/app/styles/app-bottom-navigation.css';
import App from '@/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
